import { Link } from "react-router-dom";
import { Phone, MessageSquareQuote } from "lucide-react";
import { SITE } from "@/lib/site";
import { trackPhoneClick, trackQuoteCTA } from "@/lib/analytics";

export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="floating-ctas">
      <Link
        to="/contact"
        onClick={() => trackQuoteCTA("floating")}
        data-testid="floating-quote-btn"
        className="group flex items-center gap-2 bg-gold text-black px-5 py-3 rounded-full shadow-[0_10px_40px_rgba(212,175,55,0.35)] hover:bg-gold-hi transition-all duration-300 text-[12px] uppercase tracking-[0.2em] font-semibold"
      >
        <MessageSquareQuote size={16} />
        <span className="hidden sm:inline">Get a Quote</span>
      </Link>
      <a
        href={SITE.phoneHref}
        onClick={() => trackPhoneClick("floating")}
        data-testid="floating-call-btn"
        aria-label="Call us"
        className="w-14 h-14 rounded-full bg-purple text-white flex items-center justify-center shadow-[0_10px_40px_rgba(126,34,206,0.5)] hover:bg-purple-hi transition-colors"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
